import { useSelector } from "react-redux";
import { selectIsDynamicsPredefinedOnCreateUpdateClaimEnabled } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamicsSelectors";
import { selectIsSfPredefinedOnCreateUpdateClaimEnabled } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";
import { selectIsHsPredefinedOnCreateUpdateClaimEnabled } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspotSelectors";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

const claimSelectors: Partial<Record<Integration, (state: any) => boolean>> = {
    salesforce: selectIsSfPredefinedOnCreateUpdateClaimEnabled,
    dynamics: selectIsDynamicsPredefinedOnCreateUpdateClaimEnabled,
    hubspot: selectIsHsPredefinedOnCreateUpdateClaimEnabled,
};

export const useIsPredefinedOnCreateUpdateClaimEnabled = (integrationName: Integration): boolean => {
    const selector = claimSelectors[integrationName];
    return useSelector(selector ?? (() => false));
};
